require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconChevronLeftXL.tsx
var IconChevronLeftXL_exports = {};
__export(IconChevronLeftXL_exports, {
  default: () => IconChevronLeftXL_default
});
module.exports = __toCommonJS(IconChevronLeftXL_exports);

// src/assets/monochrome/chevronLeftXL.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgChevronLeftXl = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.136 0.363602C13.4875 0.715074 13.4875 1.28492 13.136 1.63639L4.7724 10L13.136 18.3636C13.4875 18.7151 13.4875 19.2849 13.136 19.6364C12.7845 19.9879 12.2147 19.9879 11.8632 19.6364L2.86321 10.6364C2.51174 10.2849 2.51174 9.71507 2.86321 9.3636L11.8632 0.363602C12.2147 0.0121305 12.7845 0.0121305 13.136 0.363602Z", fill: "#676F7E" }) });
var chevronLeftXL_default = SvgChevronLeftXl;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconChevronLeftXL.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconChevronLeftXL = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(chevronLeftXL_default, {}) });
};
IconChevronLeftXL.displayName = "IconChevronLeftXL";
var IconChevronLeftXL_default = IconChevronLeftXL;
